export const environment = {
  production: false,
  name: 'dev',
  backendUrl: 'https://api-dev.splash.tech',
  hubFrontendUrl: 'http://localhost:4204',
  lottieAnimationEnabled: true,
};
